import React from 'react';
import bkash from '../../assets/bkash.png';
import rocket from '../../assets/rocket.png';
import nagad from '../../assets/nagad.PNG';
import HomeContainer from '../HomeContainer';

const Registration1 = () => {
  return (
    <HomeContainer>
    <div>
      <h5>Ai For Gen Z [Course Fee- Tk5100]</h5>
      <h5 style={{color:'green'}}>[Machine Learning and Deep Learning with Python]</h5>
      <div>
        
        <p>Trainee must fill up the Registration Form to register our course. Please don't submit any false information. Send Tk5100 for registration-</p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ textAlign: 'center' }}>
            <img src={bkash} alt="bKash" style={{ verticalAlign: 'middle' }} />
            <p>bKash</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <img src={rocket} alt="Rocket" style={{ verticalAlign: 'middle' }} />
            <p>Rocket</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <img src={nagad} alt="Nagad" style={{ verticalAlign: 'middle' }} />
            <p>Nagad</p>
          </div>
        </div>
        <p>Send money to Personal</p>
        {/* <p>Not agent: 01811109698</p> */}
        <h3>01811109698</h3>
        <p>In case of Rocket transfer add ‘5’ with above number.</p>
        <p>Contact us (Phone + WhatsApp)- 01759704867</p>
        <p style={{color:'green', fontWeight:'bold'}}>রেজিস্ট্রেশন ফরম পূরনের পূর্বে নির্ধারিত কোর্স ফি পরিশোধ করতে হবে।</p>
        <p style={{color:'red'}}>তালিকাভুক্ত যেকোনো জুলাই শহীদের ভাই, বোন, সন্তান এবং অঙ্গহানি হয়েছে এমন জুলাই যোদ্ধাদের প্রশিক্ষণ খরচ ‘Ai For Today’ বহন করবে। তাদের কোনো আর্থিক মূল্য পরিশোধের প্রয়োজন  নেই। তাদের অংশগ্রহনই আমাদের প্রেরণা।</p>

        
      </div>
      <span style={{fontSize:'20px', fontWeight:'bold'}}>Registration Form: </span>
      <link href=''/>
      <a style={{fontSize:'20px', fontWeight:'bold'}} href="https://docs.google.com/forms/d/e/1FAIpQLSfMcHCuw57a6A2RwYuB8voRVaZ075T8-3tBgGXyPcgorT7UOw/viewform" target="_blank" rel="noopener noreferrer">
  Go to Registration Form
</a>
    </div>
    </HomeContainer>
  );
};

export default Registration1;
